import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';

export const workspaceGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const workspaceToken = localStorage.getItem('workspace_token');
  
  return !!workspaceToken || router.createUrlTree(['/workspace/create']);
};
